import { defineMessages } from "../i18n/core";

export const activityMessages = defineMessages({
  "pt-BR": {
    title: "Atividade",
    lede: "Backups, restaurações, replicação e manutenção, do mais recente ao mais antigo.",
    kindFilter: "Tipo",
    all: "Tudo",
    onlyProblems: "Só falhas e avisos",
    colStatus: "Status",
    colKind: "Tipo",
    colMachine: "Máquina",
    colStarted: "Início",
    colDuration: "Duração",
    colData: "Dados",
    colDetail: "Detalhe",
    empty: "Nada neste filtro.",
  },
  "en-US": {
    title: "Activity",
    lede: "Backups, restores, replication and maintenance, newest first.",
    kindFilter: "Type",
    all: "All",
    onlyProblems: "Failures and warnings only",
    colStatus: "Status",
    colKind: "Type",
    colMachine: "Machine",
    colStarted: "Started",
    colDuration: "Duration",
    colData: "Data",
    colDetail: "Details",
    empty: "Nothing matches this filter.",
  },
  es: {
    title: "Actividad",
    lede: "Copias de seguridad, restauraciones, replicación y mantenimiento, de lo más reciente a lo más antiguo.",
    kindFilter: "Tipo",
    all: "Todo",
    onlyProblems: "Solo fallas y avisos",
    colStatus: "Estado",
    colKind: "Tipo",
    colMachine: "Equipo",
    colStarted: "Inicio",
    colDuration: "Duración",
    colData: "Datos",
    colDetail: "Detalle",
    empty: "No hay nada con este filtro.",
  },
});
